import type { ParagraphClientLogos as ParagraphClientLogosData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphClientLogos.module.css";

/**
 * Layout 55 - `PARAGRAPH_CLIENT_LOGOS_LAYOUT`: client logos (minimalna sekcja).
 *
 * Struktura:
 *   - Eyebrow (text_1, opcjonalny) - uppercase label nad gridem
 *   - Grid logotypow klientow - responsywny (6 col -> 4 -> 2 -> 1)
 *
 * Nazwa klienta pobierana z `img.description` (fallback: `img.alt`).
 * Typowo: sekcja "Zaufali nam" / clients wall na landing page.
 */
export function ParagraphClientLogos({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphClientLogosData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, logos } = paragraph;

  if (logos.length === 0) return null;

  const hasEyebrow = eyebrow && eyebrow.trim() !== "";

  return (
    <section className={styles.section}>
      {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
      <ul className={styles.grid}>
        {logos.map((logo) => {
          const alt = (logo.description ?? logo.alt ?? "").trim();
          return (
            <li key={logo.id} className={styles.item}>
              <img src={logo.url} alt={alt} className={styles.logo} loading="lazy" />
            </li>
          );
        })}
      </ul>
    </section>
  );
}
